import { SearchFieldWidget } from './SearchFieldWidget';
import { Link } from 'react-router';
import { filterNavigationItems } from './navigationFilter';
import * as React from 'react';
import styled from '@emotion/styled';
import { DOCS_RAIL_STICKY_TOP } from '../vars';
import { RailSurfaceWidget } from './RailSurfaceWidget';
import { TreeListItem, TreeListTone, TreeListWidget } from './TreeListWidget';

export interface NavigationTreeItem extends TreeListItem {}

export interface NavigationTreeWidgetProps {
  className?: string;
  items: NavigationTreeItem[];
  title: string;
}

export const NavigationTreeWidget: React.FC<NavigationTreeWidgetProps> = (props) => {
  const [query, setQuery] = React.useState('');
  const filtering = !!query.trim();
  const items = props.items.map((item) => normalizeNavigationItem(item));
  const filtered = filterNavigationItems(items, query);
  return (
    <S.Root className={props.className}>
      <RailSurfaceWidget label={props.title}>
        <S.Browse to="/docs/topics/">Browse all topics →</S.Browse>
        <S.Filter
          type="search"
          aria-label="Filter navigation"
          placeholder="Filter navigation…"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') setQuery('');
          }}
        />
        <div hidden={filtering}>
          <TreeListWidget items={items} />
        </div>
        {filtering &&
          (filtered.length ? (
            <TreeListWidget key={query.trim()} items={filtered} highlight={query.trim()} />
          ) : (
            <S.Empty role="status">No matching topics.</S.Empty>
          ))}
      </RailSurfaceWidget>
    </S.Root>
  );
};

const normalizeNavigationItem = (item: NavigationTreeItem): TreeListItem => {
  return {
    ...item,
    children: item.children?.map((child) => normalizeNavigationItem(child)),
    tone: item.tone ?? (!item.to && !item.onClick ? TreeListTone.GROUP : TreeListTone.DEFAULT)
  };
};

namespace S {
  export const Browse = styled(Link)`
    display: block;
    margin-bottom: 16px;
    color: ${(p) => p.theme.text.special};
    font-size: 14px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  `;
  export const Filter = styled(SearchFieldWidget)`
    margin-bottom: 16px;
  `;
  export const Empty = styled.p`
    color: ${(p) => p.theme.text.paragraph};
    font-size: 13px;
  `;

  export const Root = styled.aside`
    position: sticky;
    top: ${DOCS_RAIL_STICKY_TOP}px;
  `;
}
